import { Workbook } from 'exceljs';
import { getMonthLabel } from '../../../utils/formatters';
import { extractErrorMessage, notifyError } from '../../../utils/errorNotifier';
import { saveAs } from 'file-saver';
import { DealWithTimeLogs } from '../../../types';

export const opChargeSummaryExcelExport = async (
  data: DealWithTimeLogs[],
  year: number,
  month: number
) => {
  try {
  const title = 'OP_Charge_Summary';
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Sheet 1');

  worksheet.columns = [
    { header: '', key: 'deal', width: 25 },
    { header: '', key: 'time', width: 20 },
  ];

  const periodRow = worksheet.addRow([`Period`, `${getMonthLabel(month)} ${year}`]);
  periodRow.getCell(1).font = { bold: true };
  periodRow.getCell(2).alignment = { horizontal: 'right' };
  worksheet.addRow([]);
  const headerRow = worksheet.addRow(['Deal', 'Time Charged (%)']);
  headerRow.getCell(2).alignment = { horizontal: 'right' };
  data.forEach((row) => {
    const rows = worksheet.addRow([row.name, row.dealTimeLogs.length ? '' : '-']);
    rows.getCell(1).font = { bold: true };
    rows.getCell(2).alignment = { horizontal: 'right' };

    row.dealTimeLogs?.forEach((tl) => {
      const opRow = worksheet.addRow([tl.user.name, tl.avg.toFixed(0) + '%']);
      opRow.getCell(2).alignment = { horizontal: 'right' };
    });
    worksheet.addRow([]);
  });

  worksheet.addRow([]);

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, `${title}.xlsx`);
  } catch (error) {
    notifyError(extractErrorMessage(error));
  }
};
